module.exports = __webpack_public_path__ + "assets/img/gar8-9.5de62454.jpg";